import {$host} from "./index";

export const getChannels = async () => {
    return await $host.get('/channels')
}
